import { Alertify } from './alertify/alertify';
import { Api } from './api/api';
import { ArtistService } from './artist/artist';
import { CoachmarkService } from './coachmark/coachmark.service';
import { Config } from './config/config';
import { CountryService } from './country/country';
import { DeviceKS } from './device-ks/device-ks';
import { FacebookLoginProvider } from './facebook/facebook-login';
import { FirebaseItemsInterface } from './firebase/firebaseItemsInterface';
import { KSFirebase } from './firebase/ksfirebase';
import { FriendsService } from './friends/friends';
import { GtvZone } from './gtv/gtv';
import { LocationService } from './helpers/location';
import { TranslateInitializer } from './i18n/translate.initializer';
import { LocalStorage } from './local-storage/local-storage';
import { CustomerIoService } from './metrics/customer-io/customer-io.service';
import { MetricsService } from './metrics/metrics.service';
import { ModalService } from './modal/modal';
import { Mxp } from './mxp/mxp';
import { Notifications } from './notifications/notifications';
import { PlaylistService } from './playlist/playlist';
import { ProfilesArtistService } from './profiles-artist/profiles-artist.service';
import { RankingService } from './ranking/ranking';
import { RecordsService } from './records/records.service';
import { RegisterWebService } from './registerWeb/registerWeb';
import { RootScopeAdapter } from './root-scope-adapter/root-scope-adapter';
import { SearchAnalyzerService } from './search/search-analyzer.service';
import { SmartListService } from './smartlist/smart-list.service';
import { SmsService } from './sms/sms';
import { SongsService } from './songs/songs';
import { AuthTokenService } from './user/auth-token.service';
import { SessionService } from './user/session.service';
import { User } from './user/user';
import { UserRealtimeService } from './user/user-realtime';

export {
  Api,
  SmartListService,
  AuthTokenService,
  ArtistService,
  CoachmarkService,
  CountryService,
  FirebaseItemsInterface,
  FacebookLoginProvider,
  KSFirebase,
  LocalStorage,
  LocationService,
  PlaylistService,
  RankingService,
  TranslateInitializer,
  RegisterWebService,
  RootScopeAdapter,
  SearchAnalyzerService,
  SmsService,
  RecordsService,
  SongsService,
  Mxp,
  CustomerIoService,
  MetricsService,
  Notifications,
  Config,
  DeviceKS,
  FriendsService,
  GtvZone,
  SessionService,
  ModalService,
  User,
  ProfilesArtistService,
};

export const boostrapTestingProviders = [
  Alertify,
  Api,
  AuthTokenService,
  Config,
  CountryService,
  DeviceKS,
  LocalStorage,
  LocationService,
  Mxp,
  MetricsService,
  RootScopeAdapter,
  SessionService,
  User,
  UserRealtimeService,
];
